module.exports = __webpack_public_path__ + "static/img/xinlanlogo.f60db99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xinlanlogo.png
// module id = br0y
// module chunks = 60